import { PersonLinkHoverBgColor } from '../components/PersonLink'
import { IS_EQT_FOUNDATION } from '../utilities/site'

export const peopleHoverColorMap = IS_EQT_FOUNDATION
  ? {
      default: PersonLinkHoverBgColor.Variant3,
      eqtFoundationCommittee: PersonLinkHoverBgColor.Variant4,
      executiveBoard: PersonLinkHoverBgColor.Variant1Faded,
      managementTeam: PersonLinkHoverBgColor.Variant2Faded,
      volunteers: PersonLinkHoverBgColor.Variant3,
    }
  : {
      advisoryProfessionals: PersonLinkHoverBgColor.Variant2,
      clientRelations: PersonLinkHoverBgColor.Variant3,
      specialistFunctions: PersonLinkHoverBgColor.Variant5,
      default: PersonLinkHoverBgColor.Variant1,
    }
